module.exports = "<div class=\"css-spinner\" *ngIf=\"getVisible()\">\n\t<div></div>\n\t<div></div>\n\t<div></div>\n\t<div></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/css-spinner/css-spinner.html
// module id = 50vO
// module chunks = 12